export default __webpack_public_path__ + "static/media/ai_virtual_services_ai_photos_fr.d1ecb5a7.png";